jQuery(document).ready(function ($) {
	var STORAGE_KEY = 'auravita_site_popup_day';
	var $popup = $('#site-popup');

	function today() {
		var now = new Date();
		var month = String(now.getMonth() + 1);
		var day = String(now.getDate());
		if (month.length < 2) {
			month = '0' + month;
		}
		if (day.length < 2) {
			day = '0' + day;
		}
		return now.getFullYear() + '-' + month + '-' + day;
	}

	function dismissedToday() {
		try {
			return localStorage.getItem(STORAGE_KEY) === today();
		} catch (err) {
			return false;
		}
	}

	function rememberDismissal() {
		try {
			localStorage.setItem(STORAGE_KEY, today());
		} catch (err) {}
	}

	if (!$popup.length || dismissedToday()) {
		return;
	}

	var $closeTriggers = $popup.find('[data-site-popup-close]');
	var $closeButton = $popup.find('.site-popup__close');

	function openPopup() {
		$popup.removeClass('hidden').removeAttr('hidden').attr('aria-hidden', 'false');
		$('body').addClass('site-popup-open');
		$closeButton.trigger('focus');
	}

	function closePopup() {
		rememberDismissal();
		$popup.addClass('hidden').attr('hidden', true).attr('aria-hidden', 'true');
		$('body').removeClass('site-popup-open');
	}

	$closeTriggers.on('click', function (e) {
		e.preventDefault();
		closePopup();
	});

	// Dismiss for this session when clicking a link inside the popup,
	// so it doesn't reopen on the next page.
	$popup.on('click', 'a[href]', function () {
		rememberDismissal();
	});

	$(document).on('keydown.sitePopup', function (e) {
		if (e.key === 'Escape' && !$popup.hasClass('hidden')) {
			closePopup();
		}
	});

	openPopup();
});
